module.exports = __webpack_public_path__ + "media/images/ic_map-8ba78d89485946ca12af1eccff416e4d.svg";